<template>
	<div style="display:grid;">
		<div class="level">
			<div class="level-left">
				<div class="level-item">
					<h1 class="title">Equipos</h1>
				</div>
			</div>
			<div class="level-item">
				<div class="field">
					<div class="control">
						<input class="input is-medium" v-model="search" type="text" placeholder="Buscar..."/>
					</div>
				</div>
			</div>
			<div class="level-right">
				<div class="level-item">
					<router-link to="/admin-quini/equipos/new" class="button is-primary">+ Nuevo Equipo</router-link>
				</div>
			</div>
		</div>

		<table class="table is-bordered is-narrow is-fullwidth">
			<thead>
				<tr>
					<th>Id</th>
					<th>Nombre</th>
					<th class="is-hidden-mobile">Noticias</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="equipo in filteredList" v-bind:key="equipo.id">
					<td>{{ equipo.id }}</td>
					<td>{{ equipo.nombre }}</td>
					<td class="is-hidden-mobile">{{ equipo.noticias }}</td>
					<td>
						<router-link
						class="button is-small"
						:to="{ name: 'equipo', params: { id: equipo.id } }"
						>Editar</router-link
						>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
	import { mapState } from "vuex";

	export default {
		name: "Equipos",
		data() {
			return {
				search: ""
			};
		},
		created() {
			this.$store.dispatch("equipos/fetchEquipos");
		},
		computed: {
			filteredList() {
				var _self = this;
				return this.equipos.equipos.filter(function(equipo) {
					return equipo.nombre.toLowerCase().includes(_self.search.toLowerCase());
				});
			},
			...mapState(["equipos"])
		}
	};
</script>
